exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-2df46602] {\n  background-color: #dee2e6;\n  height: 2rem;\n  border-radius: .25rem;\n  padding: 0.5rem;\n}\n", ""]);

// exports
